"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3-time");
var models_1 = require("../models");
var Localize_1 = require("../../gen-src/Localize");
var localization_1 = require("../localization");
exports.dateFormatterFactory = function (dateTrunc, startMonth) {
    if (startMonth === void 0) { startMonth = models_1.FiscalYearStartMonth.JANUARY; }
    return ({
        dateTruncContainsTime: function () {
            switch (dateTrunc) {
                case models_1.DateTrunc.HOUR:
                case models_1.DateTrunc.MINUTE:
                case models_1.DateTrunc.SECOND:
                case models_1.DateTrunc.UNKNOWN:
                    return true;
                default:
                    return false;
            }
        },
        comparisonWidget: function (firstDate, lastDate, multiLine) {
            var _a = formatsForPair(firstDate, lastDate, dateTrunc, startMonth), format1 = _a[0], format2 = _a[1];
            var first = format1(firstDate);
            var last = format2(lastDate);
            if (multiLine) {
                return localization_1.Messages.metricsComparisonTimestampTwoLines({ first: first, last: last });
            }
            else {
                return localization_1.Messages.metricsComparisonTimestamp({ first: first, last: last });
            }
        },
        legend: function (range, multiLine) {
            var _a = formatsForPair(range.first, range.last, dateTrunc, startMonth), format1 = _a[0], format2 = _a[1];
            var firstLine = format1(range.first) + " \u2014";
            var secondLine = "" + format2(range.last);
            var singleLine = firstLine + " " + secondLine;
            if (multiLine) {
                return firstLine + '\n' + secondLine;
            }
            else {
                return singleLine;
            }
        },
        adjustAndCompare: function (range) {
            var _a = formatsForPair(range.first, range.last, dateTrunc, startMonth), format1 = _a[0], format2 = _a[1];
            return format1(range.first) + " \u2014 " + format2(range.last);
        },
        tooltip: function (date, multiLine) {
            return exports.tooltipFormatterForTrunc(dateTrunc, startMonth, multiLine)(date);
        },
        banTimestamp: function (date) {
            return exports.banTimestampFormatterForTrunc(dateTrunc, startMonth)(date);
        },
        axisTick: function (date) {
            if (fiscalYearStartsInJanuary(startMonth)) {
                return tickFormat(date);
            }
            switch (dateTrunc) {
                case models_1.DateTrunc.YEAR:
                    return fiscalYearAwareYearFormatter(startMonth)(date);
                case models_1.DateTrunc.QUARTER:
                    return exports.fiscalYearAwareQuarterFormatter(startMonth)(date);
                default:
                    return tickFormat(date);
            }
        },
    });
};
var formatsForPair = function (date1, date2, dateTrunc, startMonth) {
    switch (dateTrunc) {
        case models_1.DateTrunc.SECOND: {
            var first = yearsAreDifferent(date1, date2)
                ? function (a) { return timeThenDate(a, Localize_1.Formatters.timeWithSeconds, Localize_1.Formatters.wordyDate); }
                : datesAreDifferent(date1, date2)
                    ? function (a) { return timeThenDate(a, Localize_1.Formatters.timeWithSeconds, Localize_1.Formatters.monthAndDay); }
                    : Localize_1.Formatters.timeWithSeconds;
            var second = function (a) { return timeThenDate(a, Localize_1.Formatters.timeWithSeconds, Localize_1.Formatters.wordyDate); };
            return [first, second];
        }
        case models_1.DateTrunc.MINUTE: {
            var first = yearsAreDifferent(date1, date2)
                ? function (a) { return timeThenDate(a, Localize_1.Formatters.timeToMinute, Localize_1.Formatters.wordyDate); }
                : datesAreDifferent(date1, date2)
                    ? function (a) { return timeThenDate(a, Localize_1.Formatters.timeToMinute, Localize_1.Formatters.monthAndDay); }
                    : Localize_1.Formatters.timeToMinute;
            var second = function (a) { return timeThenDate(a, Localize_1.Formatters.timeToMinute, Localize_1.Formatters.wordyDate); };
            return [first, second];
        }
        case models_1.DateTrunc.HOUR: {
            var first = yearsAreDifferent(date1, date2)
                ? function (a) { return timeThenDate(a, Localize_1.Formatters.timeToHour, Localize_1.Formatters.wordyDate); }
                : datesAreDifferent(date1, date2)
                    ? function (a) { return timeThenDate(a, Localize_1.Formatters.timeToHour, Localize_1.Formatters.monthAndDay); }
                    : Localize_1.Formatters.timeToHour;
            var second = function (a) { return timeThenDate(a, Localize_1.Formatters.timeToHour, Localize_1.Formatters.wordyDate); };
            return [first, second];
        }
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY:
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK: {
            var first = yearsAreDifferent(date1, date2) ? Localize_1.Formatters.wordyDate : Localize_1.Formatters.monthAndDay;
            var second = Localize_1.Formatters.wordyDate;
            return [first, second];
        }
        case models_1.DateTrunc.MONTH: {
            var first = yearsAreDifferent(date1, date2) ? Localize_1.Formatters.wordyMonthYear : Localize_1.Formatters.month;
            var second = Localize_1.Formatters.wordyMonthYear;
            return [first, second];
        }
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER: {
            if (fiscalYearStartsInJanuary(startMonth)) {
                var first = yearsAreDifferent(date1, date2) ? Localize_1.Formatters.quarterYear : quarterNoYear;
                var second = Localize_1.Formatters.quarterYear;
                return [first, second];
            }
            else {
                var first = exports.fiscalYearAwareQuarterFormatter(startMonth);
                var second = yearsAreDifferent(date1, date2, startMonth)
                    ? exports.fiscalYearAwareQuarterFormatter(startMonth)
                    : exports.fiscalYearAwareQuarterNoYearFormatter(startMonth);
                return [first, second];
            }
        }
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR: {
            return [fiscalYearAwareYearFormatter(startMonth), fiscalYearAwareYearFormatter(startMonth)];
        }
        case models_1.DateTrunc.NONE:
        case models_1.DateTrunc.UNKNOWN:
        case undefined:
        default: {
            return [
                function (a) { return timeThenDate(a, Localize_1.Formatters.timeToMinute, Localize_1.Formatters.wordyDate); },
                function (a) { return timeThenDate(a, Localize_1.Formatters.timeToMinute, Localize_1.Formatters.wordyDate); },
            ];
        }
    }
};
var yearsAreDifferent = function (date1, date2, fiscalYearStartMonth) {
    if (fiscalYearStartMonth === void 0) { fiscalYearStartMonth = 1; }
    if (fiscalYearStartsInJanuary(fiscalYearStartMonth)) {
        return date1.getFullYear() !== date2.getFullYear();
    }
    else {
        return fyForDate(date1, fiscalYearStartMonth) !== fyForDate(date2, fiscalYearStartMonth);
    }
};
var fyForDate = function (date, startMonth) {
    if (beforeFYStart(date, startMonth)) {
        return date.getFullYear();
    }
    else {
        return date.getFullYear() + 1;
    }
};
var datesAreDifferent = function (date1, date2) {
    return date1.getDate() !== date2.getDate() || date1.getMonth() !== date2.getMonth();
};
exports.banTimestampFormatterForTrunc = function (dateTrunc, fiscalYearStartMonth) {
    switch (dateTrunc) {
        case models_1.DateTrunc.SECOND: {
            return Localize_1.Formatters.wordyDateWithTimeToSecond;
        }
        case models_1.DateTrunc.MINUTE: {
            return Localize_1.Formatters.wordyDateWithTimeToMinute;
        }
        case models_1.DateTrunc.HOUR: {
            return Localize_1.Formatters.wordyDateWithTimeToHour;
        }
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY: {
            return Localize_1.Formatters.wordyDate;
        }
        case models_1.DateTrunc.MONTH: {
            return Localize_1.Formatters.wordyMonthYear;
        }
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK: {
            return function (a) { return localization_1.Messages.metricsWeekOf({ week: Localize_1.Formatters.wordyDate(a) }); };
        }
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER: {
            return exports.fiscalYearAwareQuarterFormatter(fiscalYearStartMonth);
        }
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR: {
            return fiscalYearAwareYearFormatter(fiscalYearStartMonth);
        }
        case models_1.DateTrunc.NONE:
        case models_1.DateTrunc.UNKNOWN:
        case undefined:
        default: {
            return Localize_1.Formatters.wordyDateWithTimeToMinute;
        }
    }
};
exports.tooltipFormatterForTrunc = function (dateTrunc, startMonth, multiLine) {
    switch (dateTrunc) {
        case models_1.DateTrunc.SECOND: {
            return Localize_1.Formatters.timeWithSeconds;
        }
        case models_1.DateTrunc.MINUTE: {
            return multilineMinuteFormatter(multiLine);
        }
        case models_1.DateTrunc.HOUR: {
            return multiLine
                ? function (date) {
                    return timeBelowDate(date, Localize_1.Formatters.slashDate, Localize_1.Formatters.timeToHour);
                }
                : Localize_1.Formatters.dateWithTimeToHour;
        }
        case models_1.DateTrunc.ISO_WEEKDAY:
        case models_1.DateTrunc.DAY: {
            return Localize_1.Formatters.slashDate;
        }
        case models_1.DateTrunc.MONTH: {
            return Localize_1.Formatters.slashMonthYear;
        }
        case models_1.DateTrunc.ISO_WEEK:
        case models_1.DateTrunc.WEEK: {
            return multiLine
                ? function (a) { return localization_1.Messages.metricsWeekOfTwoLines({ week: Localize_1.Formatters.slashDate(a) }); }
                : function (a) { return localization_1.Messages.metricsWeekOf({ week: Localize_1.Formatters.slashDate(a) }); };
        }
        case models_1.DateTrunc.ISO_QTR:
        case models_1.DateTrunc.QUARTER: {
            return exports.fiscalYearAwareQuarterFormatter(startMonth);
        }
        case models_1.DateTrunc.ISO_YEAR:
        case models_1.DateTrunc.YEAR: {
            return fiscalYearAwareYearFormatter(startMonth);
        }
        case models_1.DateTrunc.NONE:
        case models_1.DateTrunc.UNKNOWN:
        case undefined:
        default: {
            return multilineMinuteFormatter(multiLine);
        }
    }
};
var fiscalYearStartsInJanuary = function (startMonth) { return startMonth === models_1.FiscalYearStartMonth.JANUARY; };
var beforeFYStart = function (date, startMonth) { return date.getMonth() + 1 < startMonth; };
exports.fiscalYearAwareQuarterFormatter = function (startMonth) {
    return function (date) {
        if (fiscalYearStartsInJanuary(startMonth)) {
            return Localize_1.Formatters.quarterYear(date);
        }
        else {
            var fy = fiscalYearAwareYearFormatter(startMonth)(date);
            var qN = exports.fiscalYearAwareQuarterNoYearFormatter(startMonth)(date);
            return localization_1.Messages.metricsFYQuarter({ fy: fy, qN: qN });
        }
    };
};
exports.fiscalYearAwareQuarterNoYearFormatter = function (startMonth) {
    return function (date) {
        var offset = monthOffset(startMonth);
        var newDate = new Date(date.valueOf());
        newDate.setMonth(date.getMonth() + offset);
        return quarterNoYear(newDate);
    };
};
var monthOffset = function (startMonth) {
    var o = (startMonth - 13) * -1;
    if (o === 12) {
        return 0;
    }
    return o;
};
var fiscalYearAwareYearFormatter = function (startMonth) {
    return function (date) {
        if (fiscalYearStartsInJanuary(startMonth)) {
            return Localize_1.Formatters.year(date);
        }
        else {
            if (beforeFYStart(date, startMonth)) {
                return localization_1.Messages.metricsFY({ year: Localize_1.Formatters.year(date) });
            }
            else {
                var newDate = new Date(date.valueOf());
                newDate.setFullYear(date.getFullYear() + 1);
                return localization_1.Messages.metricsFY({ year: Localize_1.Formatters.year(newDate) });
            }
        }
    };
};
function multilineMinuteFormatter(multiLine) {
    return multiLine
        ? function (date) {
            return timeBelowDate(date, Localize_1.Formatters.slashDate, Localize_1.Formatters.timeToMinute);
        }
        : Localize_1.Formatters.dateWithTimeToMinute;
}
function tickFormat(date) {
    return (d3.timeMinute(date) < date
        ? Localize_1.Formatters.timeWithSeconds
        : d3.timeHour(date) < date
            ? Localize_1.Formatters.timeToMinute
            : d3.timeDay(date) < date
                ? Localize_1.Formatters.timeToMinute
                : d3.timeMonth(date) < date
                    ? Localize_1.Formatters.monthAndDay
                    : d3.timeYear(date) < date
                        ? Localize_1.Formatters.month
                        : Localize_1.Formatters.year)(date);
}
exports.tickFormat = tickFormat;
// The Globalize library doesn't seem to like the 'QQQ' skeleton, so we just extract the quarter from the 'yQQQ'.
var quarterNoYear = function (a) {
    var quarter = Localize_1.Formatters.quarterYear(a);
    var year = Localize_1.Formatters.year(a);
    return quarter.replace(year, '').trim();
};
// There isn't a way to specify time before date in a single skeleton in the Globalize library.
// So we just put them together with a string formatter.
var timeThenDate = function (a, timeFormatter, dateFormatter) {
    return timeFormatter(a) + ", " + dateFormatter(a);
};
var timeBelowDate = function (a, dateFormatter, timeFormatter) {
    return dateFormatter(a) + "\n" + timeFormatter(a);
};
//# sourceMappingURL=dateFormatter.js.map